import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHome } from '@fortawesome/free-solid-svg-icons';

const Breadcrumb = () => {
  const location = useLocation();
  
  // Create mapping for prettier names and path relationships
  const pathMap = {
    'admin': 'Dashboard',
    'edit-data': {
      name: 'Edit Content',
      path: '/admin/edit-data'
    },
    'edit-business-info': {
      name: 'Business Information',
      parent: '/admin/edit-data'
    },
    'edit-home-hero': {
      name: 'Hero Section',
      parent: '/admin/edit-data'
    },
    'edit-home-stats': {
      name: 'Stats Section',
      parent: '/admin/edit-data'
    },
    'edit-home-gallery': {
      name: 'Gallery Section',
      parent: '/admin/edit-data'
    },
    'edit-home-reviews': {
      name: 'Reviews Section',
      parent: '/admin/edit-data'
    },
    'edit-about': {
      name: 'About Us',
      parent: '/admin/edit-data'
    },
    'edit-catering': {
      name: 'Catering',
      parent: '/admin/edit-data'
    }
  };

  // Build breadcrumb items with proper hierarchy
  const getBreadcrumbs = () => {
    const paths = location.pathname.split('/').filter(path => path !== '');
    const breadcrumbs = [];
    let currentPath = '';

    paths.forEach((path) => {
      currentPath += `/${path}`;
      
      // If this is an edit page, add the parent first
      if (pathMap[path]?.parent && !breadcrumbs.find(b => b.path === pathMap[path].parent)) {
        breadcrumbs.push({
          name: 'Edit Content',
          path: '/admin/edit-data'
        });
      }

      // Add the current path
      breadcrumbs.push({
        name: pathMap[path]?.name || 
              (pathMap[path] && typeof pathMap[path] === 'object' ? pathMap[path].name : pathMap[path]) || 
              path.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
        path: currentPath
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav className="mb-8 print:hidden">
      <ol className="flex items-center space-x-2 text-gray-600">
        <li>
          <Link 
            to="/admin" 
            className="flex items-center hover:text-blue-600 transition-colors"
          >
            <FontAwesomeIcon icon={faHome} className="text-sm" />
          </Link>
        </li>
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.path}>
            <li>
              <FontAwesomeIcon 
                icon={faChevronRight} 
                className="text-gray-400 text-xs"
              />
            </li>
            <li>
              {index === breadcrumbs.length - 1 ? (
                <span className="font-medium text-gray-800">{crumb.name}</span>
              ) : (
                <Link 
                  to={crumb.path}
                  className="hover:text-blue-600 transition-colors"
                >
                  {crumb.name}
                </Link>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb; 